/**
 * PositionWorkforceQuantityIntercept
 *
 * Intercepts the position create / delete form submissions on positions/edit
 * and dispatches `quantityimpact:check` events so the QuantityImpactPreviewDialog
 * can prompt the user before workforce driver values change.
 *
 * Configuration is read from data-* attributes on the mount element
 * (#PositionWorkforceQuantityIntercept):
 *
 *   data-preview-url          — driver impact preview endpoint URL
 *   data-is-new-position      — "true" | "false"
 *   data-position-exists      — "true" | "false"
 *   data-workforce-stats-id   — numeric ID or "" (absent)
 *   data-total-workforce      — float
 *   data-dept-stats-id        — numeric ID or "" (absent)
 *   data-dept-positions-count — float
 */
(function () {
    var mountEl = document.getElementById('PositionWorkforceQuantityIntercept');
    if (!mountEl) return;

    var driverImpactPreviewUrl = mountEl.getAttribute('data-preview-url');
    var isNewPosition = mountEl.getAttribute('data-is-new-position') === 'true';
    var positionExists = mountEl.getAttribute('data-position-exists') === 'true';
    var workforceStatsId = mountEl.getAttribute('data-workforce-stats-id') || null;
    var currentTotalWorkforce = parseFloat(mountEl.getAttribute('data-total-workforce') || '0');
    var deptWorkforceStatsId = mountEl.getAttribute('data-dept-stats-id') || null;
    var currentDeptPositionsCount = parseFloat(mountEl.getAttribute('data-dept-positions-count') || '0');

    if (workforceStatsId) workforceStatsId = parseInt(workforceStatsId, 10);
    if (deptWorkforceStatsId) deptWorkforceStatsId = parseInt(deptWorkforceStatsId, 10);

    function makePreviewUrl(sourceType, sourceId) {
        var params = new URLSearchParams({
            source_type: sourceType,
            source_id: String(sourceId),
        });
        return driverImpactPreviewUrl + '?' + params.toString();
    }

    function runChecks(checks, finalCallback) {
        var idx = 0;
        function next() {
            if (idx >= checks.length) {
                finalCallback();
                return;
            }
            var check = checks[idx++];
            window.dispatchEvent(
                new CustomEvent('quantityimpact:check', {
                    detail: {
                        previewUrl: check.previewUrl,
                        newValue: check.newValue,
                        formEl: null,
                        onConfirm: next,
                        sourceLabel: null,
                    },
                }),
            );
        }
        next();
    }

    // Submit a form after the driver-impact checks pass, guarding against the
    // legacy global comma-stripper (formatService.js) which re-fires submit via
    // unbind('submit').submit() within the same dispatch. We no-op the form's
    // native submit for the current tick so the synchronous re-fire cannot post
    // the form a second time, then submit for real (via the prototype method)
    // once the checks resolve. Restoring on the next tick keeps a
    // cancelled-then-retried submit working.
    function guardedSubmit(formEl, checks) {
        // Ignore the comma-stripper's synchronous re-fire so the driver checks
        // (and the resulting submit) run exactly once.
        if (formEl._driverCheckPending) {
            return;
        }
        formEl._driverCheckPending = true;
        var nativeSubmit = HTMLFormElement.prototype.submit.bind(formEl);
        formEl.submit = function () {};
        setTimeout(function () {
            formEl._driverCheckPending = false;
            try {
                delete formEl.submit;
            } catch (err) {
                /* no-op: submit override may already be gone */
            }
        }, 0);
        runChecks(checks, function () {
            nativeSubmit();
        });
    }

    if (isNewPosition) {
        var mainForm = document.getElementById('formUpsertPosition');
        if (mainForm) {
            mainForm.addEventListener('submit', function (e) {
                var checks = [];
                if (deptWorkforceStatsId) {
                    checks.push({
                        previewUrl: makePreviewUrl('App\\DepartmentWorkforceStats', deptWorkforceStatsId),
                        newValue: currentDeptPositionsCount + 1,
                    });
                }
                if (workforceStatsId) {
                    checks.push({
                        previewUrl: makePreviewUrl('App\\WorkforceStats', workforceStatsId),
                        newValue: currentTotalWorkforce + 1,
                    });
                }
                if (checks.length === 0) return;

                e.preventDefault();
                guardedSubmit(mainForm, checks);
            });
        }
    }

    if (positionExists) {
        var deleteForm = document.getElementById('deleteForm');
        if (deleteForm) {
            deleteForm.addEventListener('submit', function (e) {
                var checks = [];
                if (deptWorkforceStatsId) {
                    checks.push({
                        previewUrl: makePreviewUrl('App\\DepartmentWorkforceStats', deptWorkforceStatsId),
                        newValue: Math.max(0, currentDeptPositionsCount - 1),
                    });
                }
                if (workforceStatsId) {
                    checks.push({
                        previewUrl: makePreviewUrl('App\\WorkforceStats', workforceStatsId),
                        newValue: Math.max(0, currentTotalWorkforce - 1),
                    });
                }
                if (checks.length === 0) return;

                e.preventDefault();
                guardedSubmit(deleteForm, checks);
            });
        }
    }
})();
